import * as api from '../../api/appraisalDemo/global';
import { makeApiActionCreatorV3 } from '../utils';

export const VIEW_NEXT_SAVED_SEARCH = 'APPRAISAL/VIEW_NEXT_SAVED_SEARCH';
export const VIEW_PREV_SAVED_SEARCH = 'APPRAISAL/VIEW_PREV_SAVED_SEARCH';
export const CHANGE_SAVED_SEARCH = 'APPRAISAL/CHANGE_SAVED_SEARCH';
export const SAVE_CURRENT_SEARCH = 'APPRAISAL/SAVE_CURRENT_SEARCH';
export const SELECT_PROPERTY = 'APPRAISAL/SELECT_PROPERTY';
export const SELECT_YEAR = 'APPRAISAL/SELECT_YEAR';
export const UPDATE_EDIT_DATE = 'APPRAISAL/UPDATE_EDIT_DATE';
export const INIT_EDIT_DATE = 'APPRAISAL/INIT_EDIT_DATE';
export const REMOVE_EDIT_DATE = 'APPRAISAL/REMOVE_EDIT_DATE';
export const TOGGLE_MENU = 'APPRAISAL/TOGGLE_MENU';

export const PREFERENCE_FETCH_START = 'GLOBAL/PREFERENCE_FETCH_START';
export const PREFERENCE_FETCH_SUCCESS = 'GLOBAL/PREFERENCE_FETCH_SUCCESS';
export const PREFERENCE_FETCH_ERROR = 'GLOBAL/PREFERENCE_FETCH_ERROR';

export const PREFERENCE_PERSIST_START = 'GLOBAL/PREFERENCE_PERSIST_START';
export const PREFERENCE_PERSIST_SUCCESS = 'GLOBAL/PREFERENCE_PERSIST_SUCCESS';
export const PREFERENCE_PERSIST_ERROR = 'GLOBAL/PREFERENCE_PERSIST_ERROR';

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH_START,
  PREFERENCE_FETCH_SUCCESS,
  PREFERENCE_FETCH_ERROR,
);
export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST_START,
  PREFERENCE_PERSIST_SUCCESS,
  PREFERENCE_PERSIST_ERROR,
);

export function viewNextSavedSearch() {
  return async dispatch => {
    dispatch({ type: VIEW_NEXT_SAVED_SEARCH });
  };
}

export function viewPrevSavedSearch() {
  return async dispatch => {
    dispatch({ type: VIEW_PREV_SAVED_SEARCH });
  };
}

export function changeSavedSearch(index) {
  return async dispatch => {
    dispatch({ type: CHANGE_SAVED_SEARCH, data: index });
  };
}

export function saveCurrentSearch(data) {
  return async dispatch => {
    dispatch({ type: SAVE_CURRENT_SEARCH, data });
  };
}

export function selectProperty(propertyId) {
  return async dispatch => {
    dispatch({ type: SELECT_PROPERTY, data: propertyId });
  };
}

export function selectYear(year) {
  return async dispatch => {
    dispatch({ type: SELECT_YEAR, data: year });
  };
}

export function initEditData(data, title) {
  return async dispatch => {
    dispatch({ type: INIT_EDIT_DATE, data, title });
  };
}

export function updateEditData(key, data, title) {
  return async dispatch => {
    dispatch({ type: UPDATE_EDIT_DATE, data, key, title });
  };
}

export function removeEditData(key, data, title) {
  return async dispatch => {
    dispatch({ type: REMOVE_EDIT_DATE, data, key, title });
  };
}

export function toggleMenu() {
  return async dispatch => {
    dispatch({ type: TOGGLE_MENU });
  };
}
